import { jsx as L } from "react/jsx-runtime";
function l(e) {
  return /* @__PURE__ */ L(
    "svg",
    {
      width: "26",
      height: "18",
      viewBox: "0 0 26 18",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ L(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.69935 12.4767H0.977051V5.5008H5.69935L12.7833 0V17.9775L5.69935 12.4767ZM20.0553 10.3608L16.2753 14.1408L15.2142 13.0806C15.0648 12.9429 15.0648 12.7062 15.2142 12.5568L18.7206 9.0252L15.2025 5.5071C15.0522 5.3703 15.0522 5.1327 15.2025 4.9833L16.2627 3.9222L20.0553 7.7157L23.8362 3.9348L24.8964 4.9959C25.0458 5.1327 25.0458 5.3703 24.8964 5.5197L21.3783 9.0378L24.8964 12.5568C25.0458 12.7062 25.0458 12.9429 24.909 13.0932L23.8488 14.1534L20.0553 10.3608Z"
        }
      )
    }
  );
}
export {
  l as MutedIcon
};
